export interface VersionInfo {
  build_sha: string | null
  build_committed_at: string | null
}

export const FRONTEND_BUILD_SHA: string = process.env.GIT_SHA || ""
export const FRONTEND_COMMITTED_AT: string = process.env.GIT_COMMITTED_AT || ""

export async function fetchVersion(): Promise<VersionInfo | null> {
  try {
    const response = await fetch("/api/version", {
      credentials: "include",
      cache: "no-store",
    })
    if (!response.ok) {
      return null
    }
    return (await response.json()) as VersionInfo
  } catch {
    return null
  }
}
